import React from 'react';


import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid';

import {DateInput, required, TextInput, Title} from 'react-admin';
import {ReportForm} from '../../components';
import env from '../../env';
import moment from "moment/moment";
import {downloadFilePost} from "../../components/FileDownload";

const BcChiTietGiaoDichTaiKhoan = ({...props}) => {

    const [values, setValues] = React.useState({
        accountNumber: '',
        fromDate: moment().format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),
    });

    const getReportUrl = () => {
        return `${env.reportURL}/reports/bc-chi-tiet-giao-dich-theo-tai-khoan`;
    }

    const excelReport = () => {
        downloadFilePost(getReportUrl(), 'bc-chi-tiet-giao-dich-theo-tai-khoan.xlsx', values)
    };

    const validate = (val) => {
        const errors = {};
        if (val.fromDate && val.toDate && (val.fromDate > val.toDate)) {
            errors.toDate = 'To date must be greater than From date'
        }

        setValues({
            accountNumber: val.accountNumber,
            fromDate: val.fromDate,
            toDate: val.toDate
        })
        return errors;
    };

    return (
        <Card>
            <Title title="resources.bc-chi-tiet-giao-dich-theo-tai-khoan.name"/>
            <CardContent>
                <ReportForm params={values}
                            validate={validate}
                            excelReport={excelReport}
                >
                    <Grid container spacing={8}>
                        <Grid item xs={12} sm={6}>
                            <DateInput label="resources.common.fromDate" source="fromDate"
                                       validate={required()} {...props} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <DateInput label="resources.common.toDate" source="toDate"
                                       validate={required()} {...props} />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <TextInput label="resources.bc-chi-tiet-giao-dich-theo-tai-khoan.accountNumber"
                                       source="accountNumber"
                                       validate={required()} {...props} />
                        </Grid>
                    </Grid>
                </ReportForm>
            </CardContent>
        </Card>
    )
}

export default BcChiTietGiaoDichTaiKhoan

